export default class EmailCampaign {
	id!: number;
	name!: string;
	subject!: string;
	message!: string;
	targetPreset!: string;
	targetDistricts?: number[];
	targetCustomSql?: string;
	requireLinkVerification!: boolean;
	requirePasswordVerification!: boolean;
	requireCodeVerification!: boolean;
	enableStudentMerge!: boolean;
	studentFilter?: string;
	isTest!: boolean;
	isActive!: boolean;
	visibleTo!: string;
	sentAt?: Date;
	pdfAttachmentPath?: string | null;
	statistics?: {
		total: number;
		sent: number;
		clicked: number;
		passwordVerified: number;
		codeVerified: number;
	};

	static fromApiResponse(data: any): EmailCampaign {
		const campaign = new EmailCampaign();
		campaign.id = data.id;
		campaign.name = data.name;
		campaign.subject = data.subject;
		campaign.message = data.message;
		campaign.targetPreset = data.target_preset;
		campaign.targetDistricts = data.target_districts;
		campaign.targetCustomSql = data.target_custom_sql;
		campaign.requireLinkVerification = data.require_link_verification;
		campaign.requirePasswordVerification = data.require_password_verification;
		campaign.requireCodeVerification = data.require_code_verification;
		campaign.enableStudentMerge = data.enable_student_merge;
		campaign.studentFilter = data.student_filter;
		campaign.isTest = data.is_test;
		campaign.isActive = data.is_active;
		campaign.visibleTo = data.visible_to;
		campaign.sentAt = data.sent_at ? new Date(data.sent_at) : undefined;
		campaign.pdfAttachmentPath = data.pdf_attachment_path ?? null;
		campaign.statistics = data.statistics;
		return campaign;
	}
}
